import { render, staticRenderFns } from "./EocViewNutritionalJournal.vue?vue&type=template&id=5869c6b2&scoped=true&"
import script from "./EocViewNutritionalJournal.vue?vue&type=script&lang=js&"
export * from "./EocViewNutritionalJournal.vue?vue&type=script&lang=js&"
import style0 from "./EocViewNutritionalJournal.vue?vue&type=style&index=0&id=5869c6b2&prod&scoped=true&lang=css&"
import style1 from "./EocViewNutritionalJournal.vue?vue&type=style&index=1&id=5869c6b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869c6b2",
  null
  
)

export default component.exports